(function () {
    if (location.hash) {
        // console.log(location.hash)
        let target = location.hash;
        if (!target.includes("#/events/")) {
            setTimeout(function () {
                let siteHeaderHeight = document.querySelector('.site-header').offsetHeight;
                // console.log(siteHeaderHeight)
                let targetEl = document.querySelector(target);
                // console.log(targetEl)
                if (targetEl) {
                    let anchorPos = targetEl.offsetTop;
                    // console.log(anchorPos)
                    window.scrollTo(0, anchorPos);
                }
            }, 100);
        }
    }

})();
